import React, { useState } from 'react';
import { Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import modalclose from '../../../images/close1.png';
import pdfIcon from '../../../images/pdfIcon.png';
import { AddUserButton, CommonButton } from '../../CommonComponents';
import Lightbox from 'react-image-lightbox';
import './index.css';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';

const UploadModal = ({ isOpen, toggle, isModalLoading, modalData, uploadKey, handleChangeMoreDoc, handleDeleteDoc, handleUploadDoc }) => {
    const [isPreviewImg, setIsPreviewImg] = useState(false);
    const [lightBoxUrl, setLightBoxUrl] = useState('');

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered className="UploadModal" id="UploadModal" scrollable={true}>
            {isModalLoading && <CustomSpinner />}
            <ModalHeader>
                <div className='modalHeading flex-wrap justify-content-between mb-0'>
                    <div className='title text-left'>Upload Selected Document</div>
                    <div className='fileButton'>
                        <AddUserButton name='Add More' btnClass={'btnPrimary'} type="button" customClass='addMoreBtn' />
                        <input
                            type='file'
                            className='fileInput'
                            title="&nbsp;"
                            multiple 
                            accept="image/*, application/pdf"
                            onChange={(e) => handleChangeMoreDoc(e, uploadKey)}
                        />
                    </div>

                </div>
            </ModalHeader>
            <ModalBody className='pl-0 pr-0 pb-0'>
                <Container>
                    <div className='uploadDocWrapper'>
                        <Row>
                            {modalData && modalData.length > 0 ? (
                                modalData.map((elem, index) => {
                                    return (
                                        <Col lg={3} md={4} sm={6} xs={12} className='mb-3' key={index}>
                                            <div className='docArea'>
                                                {elem.filename.includes('.pdf') ?
                                                    <img src={pdfIcon} alt='Images' className='img-fluid ulpoadedImg pdfImg cursorPointer' onClick={() => { }} />
                                                    :
                                                    <img src={elem.url} alt='Images' className='img-fluid ulpoadedImg' onClick={() => {
                                                        setLightBoxUrl(elem.url);
                                                        setIsPreviewImg(true)
                                                    }} />

                                                }
                                                <div className='removeIcon' onClick={() => handleDeleteDoc(uploadKey, index)}>
                                                    <img src={modalclose} alt='modalclose' />
                                                </div>
                                                <div className='imgTitle'>{elem.filename}</div>
                                            </div>
                                        </Col>
                                    )
                                })
                            ) : <Col xs={12}>
                                <div className='mb-3'>No documents found!!!</div>
                            </Col>
                            }
                        </Row>
                    </div>
                    {isPreviewImg && (
                        <Lightbox
                            mainSrc={lightBoxUrl}
                            onCloseRequest={() => setIsPreviewImg(false)}
                        />
                    )}
                </Container>
            </ModalBody>
            <ModalFooter className='pt-0 pb-0'>
                <CommonButton name={'Close'} btnClass={'btnSecondary'} type="button" onClick={toggle} />
                <CommonButton name={'Upload'} btnClass={'btnPrimary'} type="button" disabled={modalData && modalData.length > 0 ? false : true} onClick={() => handleUploadDoc(uploadKey)} />
            </ModalFooter>
        </Modal>
    )
}

export default UploadModal
